import {omit} from 'lodash'
import {useEffect} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {useParams} from 'react-router'
import {useHistory} from 'react-router-dom'

import {useTranslation} from '../../../../hooks/useTranslation'

import {CustomerTierSettingsDetails} from './components/CustomerTierSettingsDetails'
import {useCustomerTierSettingCreateMutation} from './hooks/useCustomerTierSettingsMutations'
import {useCustomerTierSettingsQuery} from './hooks/useCustomerTierSettingsQuery'
import {CustomerTierSettings} from './types/CustomerTierSettings'

export const CustomerTierSettingsCopy = () => {
  const {tierSettingsId: tierSettingsId} = useParams<{
    tierSettingsId?: string
  }>()
  const {t} = useTranslation()
  const history = useHistory()
  const customerTierSettingsMutation = useCustomerTierSettingCreateMutation()
  const customerTierSettingsQuery = useCustomerTierSettingsQuery()

  const methods = useForm<CustomerTierSettings>({
    defaultValues: {} as CustomerTierSettings,
    mode: 'onChange'
  })

  useEffect(() => {
    if (tierSettingsId && customerTierSettingsQuery.data) {
      const settings = customerTierSettingsQuery.data.find(
        (settings) => settings.id === tierSettingsId
      )
      if (settings) {
        const settingsWithoutId = omit(settings, 'id')
        methods.reset(settingsWithoutId)
      }
    }
  }, [tierSettingsId, customerTierSettingsQuery.data, methods])

  const handleCopyButtonClick = async (data: CustomerTierSettings) => {
    try {
      await customerTierSettingsMutation.mutateAsync(data)
    } finally {
      history.goBack()
    }
  }

  if (customerTierSettingsQuery.isLoading || !customerTierSettingsQuery.data) {
    return (
      <div>{t('configurations.hconnect.customerTierSettings.configurationDetails.loading')}</div>
    )
  }

  return (
    <FormProvider {...methods}>
      <CustomerTierSettingsDetails
        mode="copy"
        configId={tierSettingsId}
        onSaveButtonClick={methods.handleSubmit(handleCopyButtonClick)}
        customerTierSetting={{} as CustomerTierSettings}
        isSubmitting={customerTierSettingsMutation.isLoading}
      />
    </FormProvider>
  )
}
